import { callApiNew } from 'src/middleware/apiMiddleware';

// get calls

const acceptInvite = (token: string) =>
  callApiNew({
    endpoint: `/business/accept-invite/${token}`,
  });

const verifyInvite = (token: string) =>
  callApiNew<DecodedToken>({
    endpoint: `/business/verify-invite/${token}`,
    authenticated: false,
  });

// post calls

const signIn = (creds: UserSignInPayload) =>
  callApiNew<UserSignInResponse>({
    endpoint: '/signin',
    authenticated: false,
    body: creds,
    method: 'POST',
  });

const googleSignIn = (data: SocialOAuthParams) =>
  callApiNew<SocialOAuthResponse>({
    endpoint: '/social-oauth/google',
    method: 'POST',
    body: data,
    authenticated: false,
  });

const signUp = (data: FormData) =>
  callApiNew<User>({
    endpoint: '/signup',
    method: 'POST',
    authenticated: false,
    body: data,
  });

const forgotPassword = (email: string) =>
  callApiNew({
    endpoint: '/forgot-password',
    method: 'POST',
    authenticated: false,
    body: { email },
  });

const verifyEmailVerificationCode = (otpCode: string, email: string, action: EmailVerificationCodeAction) =>
  callApiNew<TokensResponse>({
    endpoint: `/verify/${action}`,
    method: 'POST',
    authenticated: false,
    body: { otpCode, email },
  });

const resendEmailVerificationCode = (email: string, action: EmailVerificationCodeAction) =>
  callApiNew({
    endpoint: `/resend/${action}`,
    method: 'POST',
    authenticated: false,
    body: { email },
  });

const apiUtil = {
  acceptInvite,
  verifyInvite,
  signIn,
  googleSignIn,
  signUp,
  forgotPassword,
  verifyEmailVerificationCode,
  resendEmailVerificationCode,
};

export default apiUtil;
